import { resolveRuntimeApiBaseUrl, resolveRuntimeEnvironmentBadgeLabel } from './runtime-config';

export const environment = {
  name: 'recette',
  production: false,
  apiBaseUrl: resolveRuntimeApiBaseUrl(''),
  environmentBadgeLabel: resolveRuntimeEnvironmentBadgeLabel('Recette / Non production')
};
